import { Component, Host, h, Prop, State, Element } from '@stencil/core';

@Component({
    tag: 'sew-ws-product-links',
    styleUrl: 'sew-ws-product-links.scss',
    shadow: false,
})
export class SewWsProductLinks {
    @Element() host: HTMLSewWsProductLinksElement;

    @State() expanded = false;
    @State() expandable = false;

    @Prop() headline: string;
    @Prop() showMoreLabel: string;
    @Prop() showLessLabel: string;

    private showMore = () => {
        this.expanded = !this.expanded;
    };

    componentDidLoad(): void {
        if (this.host.querySelectorAll('sew-ws-product-links-item').length > 5) {
            this.expandable = true;
        }
    }

    render() {
        return (
            <Host class={{ expanded: this.expanded }}>
                <div class="grid">
                    <div class="main-content-container">
                        <h2 class="headline" innerHTML={this.headline}></h2>
                        <div class="items">
                            <slot></slot>
                        </div>
                        {this.expandable && (
                            <button class="show-more-btn" onClick={this.showMore}>
                                {!this.expanded ? this.showMoreLabel : this.showLessLabel}
                            </button>
                        )}
                    </div>
                </div>
            </Host>
        );
    }
}
